import * as R from 'ramda';
import { useDispatch } from 'react-redux';
import React, { useCallback } from 'react';
// components
import { LocalLoader } from '../local-loader';
import { openModal, closeAllModals } from '../modal/actions';
// features
import { setExpandedContainerOptions } from '../../features/expanded-container/actions';
// helpers/constants
import * as G from '../../helpers';
import * as GC from '../../constants';
import { asyncGetReferenceDuplicates } from '../../helpers/api-async';
// ui
import { Box } from '../../ui';
//////////////////////////////////////////////////

const modalWidth = 400;
const blueColor = G.getTheme('colors.dark.blue');

export const ReferenceDuplicates = (props) => {
  const { types, noAction, duplicates } = props;
  const dispatch = useDispatch();

  const indexedTypes = R.indexBy(R.prop(GC.FIELD_VALUE), types);

  const handleReferenceClick = (guid) => {
    dispatch(closeAllModals());
    dispatch(setExpandedContainerOptions({
      opened: true,
      visitPageGuid: guid,
      componentType: GC.PAGE_DISPATCH_DETAILS_NEW_ORDER,
    }));
  };

  return (
    <LocalLoader p={15} width={modalWidth} localLoaderOpen={R.isNil(duplicates)}>
      <Box width='100%'>
        {G.isNotNil(duplicates) && duplicates.map(({ value, cloGuid, referenceTypeGuid }, i) => (
          <Box
            key={i}
            py='4px'
            color={noAction ? null : blueColor}
            cursor={noAction ? 'initial' : 'pointer'}
            onClick={noAction ? null : () => handleReferenceClick(cloGuid)}
          >
            {R.pathOr('', [referenceTypeGuid, GC.FIELD_LABEL], indexedTypes)} - {value}
          </Box>
        ))}
        {R.isEmpty(duplicates) && <Box>{G.getWindowLocale('titles:no-duplicates', 'No Duplicates')}</Box>}
      </Box>
    </LocalLoader>
  );
};

const CheckButton = ({ noAction, references, branchGuid, referenceTypes }) => {
  const dispatch = useDispatch();

  const handleOpenDuplicates = useCallback(async () => {
    const duplicates = await asyncGetReferenceDuplicates({ references, branchGuid });

    const modal = {
      p: '0',
      options: {
        width: modalWidth,
        withCloseIcon: true,
        title: G.getWindowLocale('titles:duplicates', 'Duplicates'),
      },
      component: (
        <ReferenceDuplicates
          noAction={noAction}
          types={referenceTypes}
          duplicates={duplicates}
        />
      ),
    };

    dispatch(openModal(modal));
  }, [references, branchGuid, referenceTypes]);

  return (
    <Box
      px={15}
      mb='8px'
      cursor='pointer'
      color={blueColor}
      textAlign='center'
      onClick={handleOpenDuplicates}
    >
      {G.getWindowLocale('actions:check-duplicates', 'Check Duplicates')}
    </Box>
  );
};

const CheckReferenceDuplicates = (props) => {
  const {
    noAction,
    references,
    branchGuid,
    referenceTypes,
    configReferences,
  } = props;

  if (R.isNil(configReferences)) return null;

  const checkList = R.filter(
    ({ value, referenceTypeGuid }) => R.and(
      G.isNotNilAndNotEmpty(value),
      R.includes(referenceTypeGuid, configReferences),
    ),
    references,
  );

  if (R.isEmpty(checkList)) return null;

  return (
    <CheckButton
      noAction={noAction}
      references={checkList}
      branchGuid={branchGuid}
      referenceTypes={referenceTypes}
    />
  );
};

export default CheckReferenceDuplicates;
